<template>
  <span>
    <span v-if="!isEdit">{{labelName}}</span>
    <el-select v-else  :disabled="disabled" filterable  v-model="value" @change="handleChange" :multiple="multiple">
      <el-option v-for="(item, index) in typeDatas" :key="index" :value="item[idKey]" :label="item[nameKey]"></el-option>
    </el-select>
  </span>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'select-type-by-api',
  components: {},
  props: {
    id: {
      type: [String],
      default: ''
    },
    name: {
      type: [String],
      default: ''
    },
    otherQuery: {
      type: Array,
      default() {
        return [{
          key: '',
          relation: '',
          value: ''
        }];
      }
    },
    idKey: [String],
    nameKey: [String],
    disabled: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    apiName: {
      type: String,
      default: ''
    },
    getDataMethod: {
      type: String,
      default: 'load'
    }
  },
  data() {
    return {
      typeDatas: []
    };
  },
  destroyed() {
  },
  computed: {
    labelName() {
      return '';
    },
    value: {
      get() {
        if (this.multiple) {
          return this.id && this.id.split('/') || [];
        } else {
          return this.id;
        }
      },
      set(val) {
        const postobj = {};
        if (val instanceof Array) {
          postobj.id = val.join('/');
          this.$emit('update:id', postobj.id);
          const item = this.typeDatas.filter(item => val.includes(item[this.idKey]));
          postobj.name = item.map(m => m[this.nameKey]).join('/');
          this.$emit('update:name', postobj.name);
        } else {
          postobj.id = val;
          this.$emit('update:id', val);
          const item = this.typeDatas.find(item => item[this.idKey] === val);
          postobj.name = item && item[this.nameKey] || val.join('/');
          this.$emit('update:name', postobj.name);
        }
        this.postData(postobj);
      }
    }
  },
  watch: {
  },
  created() {
    this.initView();
  },
  methods: {
    getListByApi(data) {
      if (this.apiName) {
        return request({
          url: '/' + this.apiName + '/' + this.getDataMethod + '',
          method: 'post',
          data
        });
      }
    },
    initView() {
      this.getList();
    },
    getList() {
      const listQuery = {
        page: 1,
        limit: 9999,
        wheres: ''
      };
      const tempotherQuery = this.otherQuery.filter(m =>
        m.key && m.key !== '' && m.value && m.value !== ''
      );
      if (tempotherQuery.length > 0) {
        const wheresObj = [];
        tempotherQuery.forEach(item => {
          wheresObj.push({
            field: item.key,
            value: item.value,
            relation: item.relation ? item.relation : '=='
          });
        });
        listQuery.wheres = JSON.stringify(wheresObj);
      }
      this.getListByApi(listQuery).then(res => {
        this.typeDatas = res.data;
      });
    },
    handleChange(val) {
      this.$emit('change', val);
    },
    postData(val) {
      this.$emit('postdata', val);
    }
  }
};

</script>

<style scoped>
.el-select {
 display: block;
}
</style>
